<div class="container-fluid">
  <div class="titleContainer">
    <div class="pageTitle">{{ "followUp.title" | translate }}</div>
    <div class="buttonsContainer">
      @if (user && user.is_parent) {
        <div
          (click)="addParent()"
          [class.disabled]="shouldDisableAddButton(Role.parent)"
          class="addBtn parent"
          >
          <i class="bi bi-plus-lg"></i>
          <span>{{ "followUp.addParentButton" | translate }}</span>
        </div>
      }
      @if (user && user.is_parent) {
        <div
          (click)="addChild()"
          [class.disabled]="shouldDisableAddButton(Role.enfant)"
          class="addBtn child"
          >
          <i class="bi bi-plus-lg"></i>
          <span>{{ "followUp.addChildButton" | translate }}</span>
        </div>
      }
    </div>
  </div>
  <div class="tableContainer">
    <p-table
      [value]="followup"
      styleClass="p-datatable-striped"
      [tableStyle]="{ 'border-radius': '24px' }"
      >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "followUp.table.lastname" | translate }}</th>
          <th>{{ "followUp.table.firstname" | translate }}</th>
          @if (shouldDisplaySchoolName()) {
            <th>
              {{ "followUp.table.school" | translate }}
            </th>
          }
          <th>{{ "followUp.table.progress" | translate }}</th>
          <th>{{ "followUp.table.lastValidation" | translate }}</th>
          <th>{{ "followUp.table.limitDate" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fu>
        <tr>
          <td>{{ fu.user_infos.last_name }}</td>
          <td>{{ fu.user_infos.first_name }}</td>
          @if (shouldDisplaySchoolName()) {
            <td>
              {{ fu.user_infos.school_name }}
            </td>
          }
          <td>
            <div class="globalProgressContainer">
              <div class="progressText">
                {{ fu.global_score }} /
                {{ fu.global_max_score }}xp
              </div>
              <div class="progressBarContainer">
                <p-progressBar
                  [value]="getGlobalProgressValueFrom(fu)"
                  >
                  <ng-template pTemplate="content" let-value>
                    <span></span>
                  </ng-template>
                </p-progressBar>
                <i
                  (click)="displayDetails(fu.progresses)"
                  class="bi bi-info-circle"
                ></i>
              </div>
            </div>
          </td>
          <td>
            @if (
              dates[fu.user_id] === undefined ||
              dates[fu.user_id].date === undefined
              ) {
              <p-tag
                [severity]="'danger'"
                            [value]="
                                translationService.instant(
                                    'followUp.table.tags.nothingValidated'
                                )
                            "
                />
            }
            @if (
              dates[fu.user_id] !== undefined &&
              dates[fu.user_id].date !== undefined
              ) {
              <p-tag
                            [severity]="
                                getSeverityForLastValidated(dates[fu.user_id])
                            "
                            [value]="
                                getStringForLastValidated(dates[fu.user_id])
                            "
                />
            }
          </td>
          <td>
            <p-tag
                            [value]="
                                fu.user_infos.limit_date ??
                                translationService.instant(
                                    'followUp.table.tags.noLimitDate'
                                )
                            "
              [severity]="getSeverity(fu.user_infos.limit_date)"
              />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
@if (progressInfo) {
  <div class="progressDetailsCardContainer">
    <div class="progressDetails">
      <div class="headlineContainer">
        <div class="pageTitle">Détails des modules</div>
        <div (click)="exitDetails()" class="closeButton">
          <i class="bi bi-x-square"></i>
        </div>
      </div>
      <p-scrollPanel
            [style]="{
                width: '100%',
                height: 'calc(50vh - (48px + 32px + 24px))'
            }"
        >
        <div class="details">
          @for (progress of progressInfo; track progress; let i = $index) {
            <div
              class="detailsModule"
              >
              <div class="line">
                <div class="moduleName">
                  {{ getModuleName(progress.module_id) }}
                </div>
                <div class="progressContainer">
                  <p-progressBar
                    [value]="getProgressValueFrom(progress)"
                    >
                    <ng-template pTemplate="content" let-value>
                      <span></span>
                    </ng-template>
                  </p-progressBar>
                </div>
              </div>
              @if (i < progressInfo.length - 1) {
                <p-divider />
              }
            </div>
          }
        </div>
      </p-scrollPanel>
    </div>
  </div>
}
